var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1063_30818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.5293C7.91421 3.5293 8.25 3.86508 8.25 4.2793C8.25 4.69351 7.91421 5.0293 7.5 5.0293H3.75V14.0293H12.75V10.2793C12.75 9.86508 13.0858 9.5293 13.5 9.5293C13.9142 9.5293 14.25 9.86508 14.25 10.2793V13.5293C14.25 14.6339 13.3546 15.5293 12.25 15.5293H4.25C3.14543 15.5293 2.25 14.6339 2.25 13.5293V5.5293C2.25 4.42473 3.14543 3.5293 4.25 3.5293H7.5Z",
    fill: "#F66800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.37498 9.98669C6.08209 10.2796 6.08209 10.7545 6.37498 11.0473C6.66787 11.3402 7.14275 11.3402 7.43564 11.0473L13.2974 5.18557L13.2974 7.12494C13.2974 7.53916 13.6332 7.87494 14.0474 7.87494C14.4616 7.87494 14.7974 7.53916 14.7974 7.12494L14.7974 3.62494C14.7974 3.07266 14.3497 2.62494 13.7974 2.62494L10.2974 2.62495C9.8832 2.62495 9.54742 2.96073 9.54742 3.37495C9.54742 3.78916 9.8832 4.12494 10.2974 4.12494L12.2367 4.12494L6.37498 9.98669Z",
    fill: "#F66800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1063_30818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternal);
export default __webpack_public_path__ + "static/media/internal.3337a3acb0d22767405d99416e416ce9.svg";
export { ForwardRef as ReactComponent };